import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = (type = "restaurant") => {
  let path = "";
  switch (type) {
    case "restaurant":
      path = "/consumer/restaurant";
      break;
    default:
      break;
  }
  return APIHost() + ":3333" + path;
};

export const loadRestaurant = (params) => {
  const url = `${baseURL()}/load`;
  return axios.post(url, params, {
    timeout: 180000,
  });
};

export const SearchByES = (params) => {
  const url =
    APIHost() === "https://api-live-web.lolol.com"
      ? `${APIHost()}:3600/searchopen` // live
      : "http://129.126.133.188:3601/searchopen"; // stage
  return axios.post(url, params, {
    timeout: 180000,
  });
};

export const getRestaurantDetail = (id) => {
  const url = `${baseURL()}/detail/${id}`;
  return axios.get(url);
};

export const loadRestaurantAlbum = (restID, album, offset, limit) => {
  const url = `${baseURL()}/album/${restID}/${album}${
    offset !== null
      ? limit !== null
        ? "/" + offset + "/" + limit
        : "/" + offset
      : ""
  }`;
  return axios.get(url);
};

export const checkRestaurantCoverage = (params) => {
  const url = `${baseURL()}/coverage/${params.id}`;
  return axios.post(url, params);
};

// General
export const getShopLololID = (params) => {
  const url = `${baseURL("general")}/merchant`;

  return axios.post(url, params);
};

export const getStateList = (state, district) => {
  const url = `${baseURL("general")}/state${
    state !== null
      ? district !== null
        ? "/" + state + "/" + district
        : "/" + state
      : ""
  }`;
  return axios.get(url);
};

export const getDeliveryFee = () => {
  const url = `${baseURL("general")}/consumer/deliveryFee`;
  return axios.get(url);
};

export const getRestaurantFilterList = (value) => {
  const url = `${baseURL()}/filter/${value}`;
  return axios.get(url);
};

export const checkPaymentCode = (code) => {
  const url = `${baseURL("general")}/codeChecking/${code}`;
  return axios.get(url);
};

export const updateViewCount = (params) => {
  const url = `${baseURL("general")}/view`;
  return axios.post(url, params);
};

export const getDeliveryAnnouncement = (params) => {
  const url = APIHost() + ":3005/consumer/getDeliveryAnnouncement";
  //   console.log(url, params, "announcement");
  return axios.post(url, params);
};
